import { render, staticRenderFns } from "./TaskFormDialog.vue?vue&type=template&id=952d361a&scoped=true&"
import script from "./TaskFormDialog.vue?vue&type=script&lang=js&"
export * from "./TaskFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskFormDialog.vue?vue&type=style&index=0&id=952d361a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952d361a",
  null
  
)

export default component.exports